const actions = {
  DO_LOGIN: "auth/DO_LOGIN",
  SET_LOGIN: "auth/SET_LOGIN",
};

export default actions;
